import {REMOVE_REGION_LIST, SET_REGION_LIST} from "./types";
const actions = {
    setRegionList: ({commit}, regionList) => {
        commit(SET_REGION_LIST, regionList)
    },
    removeRegionList: ({commit}, regionList) => {
        commit(REMOVE_REGION_LIST, regionList)
    },

}
export default actions